const META_PIXEL_SCRIPT_ID = "lotq-meta-pixel";

let activePixelId = null;

function getCookie(name) {
  if (typeof document === "undefined") return "";
  const prefix = `${encodeURIComponent(name)}=`;
  return document.cookie
    .split(";")
    .map((entry) => entry.trim())
    .find((entry) => entry.startsWith(prefix))
    ?.slice(prefix.length) || "";
}

function ensureFacebookClickCookie() {
  if (typeof window === "undefined") return;
  const clickId = new URLSearchParams(window.location.search).get("fbclid");
  if (!clickId) return;

  if (getCookie("_fbc").endsWith(`.${clickId}`)) return;

  const maxAge = 90 * 24 * 60 * 60;
  document.cookie = `_fbc=fb.1.${Date.now()}.${clickId}; Path=/; Max-Age=${maxAge}; SameSite=Lax; Secure`;
}

export function initializeMetaPixel(pixelId = process.env.REACT_APP_META_PIXEL_ID) {
  if (typeof window === "undefined") return false;
  const normalizedId = String(pixelId || "").trim();
  if (!normalizedId) return false;

  ensureFacebookClickCookie();
  window.fbq = window.fbq || function metaPixelQueue() {
    window.fbq.callMethod
      ? window.fbq.callMethod.apply(window.fbq, arguments)
      : window.fbq.queue.push(arguments);
  };
  window.fbq.push = window.fbq;
  window.fbq.loaded = true;
  window.fbq.version = "2.0";
  window.fbq.queue = window.fbq.queue || [];

  if (!document.getElementById(META_PIXEL_SCRIPT_ID)) {
    const script = document.createElement("script");
    script.id = META_PIXEL_SCRIPT_ID;
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    script.onerror = () => console.warn("Não foi possível carregar o Meta Pixel.");
    document.head.appendChild(script);
  }

  if (activePixelId !== normalizedId) {
    window.fbq("init", normalizedId);
    activePixelId = normalizedId;
  }
  return true;
}

export function trackMetaPageView(pixelId) {
  if (!initializeMetaPixel(pixelId)) return;
  window.fbq("track", "PageView");
}

export function trackMetaEvent(eventName, parameters = {}, eventId = "") {
  if (!initializeMetaPixel()) return;
  const options = eventId ? { eventID: String(eventId) } : undefined;
  window.fbq("track", eventName, parameters, options);
}

export function buildMetaCheckoutPayload(event, { value = 0, quantity = 1 } = {}) {
  const eventId = String(event?.id || "").trim();
  return {
    content_ids: eventId ? [eventId] : [],
    content_name: String(event?.thematic_round_theme || event?.title || "Lord of the Quiz").trim(),
    content_category: String(event?.venue?.name || event?.location || event?.event_type || "Evento").trim(),
    content_type: "product",
    currency: "BRL",
    value: Number(value || 0),
    num_items: Math.max(1, Number(quantity) || 1),
  };
}
